"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5208],{

/***/ 25208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5ZM12 7C7 7 3 11 3 16C3 16.6 3.4 17 4 17H20C20.6 17 21 16.6 21 16C21 11 17 7 12 7ZM18.9 15C18.4 11.6 15.5 9 12 9C8.5 9 5.6 11.6 5.1 15H18.9ZM4 19C3.4 19 3 19.4 3 20C3 20.6 3.4 21 4 21H20C20.6 21 21 20.6 21 20C21 19.4 20.6 19 20 19H4ZM12.9998 10.9003C13.2998 10.4003 13.8998 10.2003 14.3998 10.5003C15.2998 11.0003 16.0998 11.6003 16.8998 12.4003C17.2998 12.8003 17.1998 13.4003 16.7998 13.8003C16.5998 13.9003 16.2998 14.0003 16.0998 14.0003C15.7998 14.0003 15.4998 13.9003 15.2998 13.7003C14.6998 13.1003 14.0998 12.6003 13.3998 12.2003C12.8998 12.0003 12.6998 11.3003 12.9998 10.9003Z"
}), "GuestService"));


/***/ })

}]);